import { lazy, Suspense, useState } from "react"
import { Badge } from "@mui/material"
import ChatBubbleOutline from "@mui/icons-material/ChatBubbleOutline"
import { StatButton } from "react-ui-components/components/StatButton"
import { useAuthState } from "react-firebase-hooks/auth"
import { auth } from "../firebaseAuth"
import { useNamespacedTranslation } from "../hooks/useNamespacedTranslation"
import { openLoginPopup } from "../utils/lazyPopups"
import { useCommentNotifications } from "./useCommentNotifications"

const NotificationList = lazy(() => import("./CommentNotificationsList"))

function AccountNotifications({ uid }: { uid: string }) {
  const { t } = useNamespacedTranslation("comments")
  const [open, setOpen] = useState(false)
  const [unreadOnly, setUnreadOnly] = useState(false)
  const inbox = useCommentNotifications(uid, open, unreadOnly)
  return <>
    <StatButton link label={t("Comment")} ariaLabel={t("Comment notifications")}
      onClick={() => { if (!uid) void openLoginPopup(); else setOpen(true) }}
      icon={inbox.count > 0 ? <Badge badgeContent={inbox.count} max={9999} sx={{ "& .MuiBadge-badge": { bgcolor: "#f26522", color: "white", minWidth: 17, height: 17, fontSize: 10, px: 0.25, top: 9, right: 2 } }}>
        <ChatBubbleOutline sx={{ color: "white", fontSize: 24 }} />
      </Badge> : <ChatBubbleOutline sx={{ color: "white", fontSize: 24 }} />} />
    {open ? <Suspense fallback={null}><NotificationList inbox={inbox} unreadOnly={unreadOnly} onFilter={setUnreadOnly} onClose={() => setOpen(false)} /></Suspense> : null}
  </>
}
export default function CommentNotificationsButton() {
  const [user] = useAuthState(auth)
  const uid = user && !user.isAnonymous ? user.uid : ""
  // Remount on account changes: neither cached data nor pending requests cross users.
  return <AccountNotifications key={uid} uid={uid} />
}
